module.exports = __webpack_public_path__ + "img/question.476231be.svg";